import { render, staticRenderFns } from "./EvaluationButton.vue?vue&type=template&id=1b80b29c&"
import script from "./EvaluationButton.vue?vue&type=script&lang=js&"
export * from "./EvaluationButton.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports